import { BACKEND_URL, JWT_KEY } from '../config';
import { getWithExpiry } from './localStorageService';

const getAuthHeader = () => ({
  'Content-Type': 'application/json',
  'Accept-Encoding': 'gzip',
  Authorization: `Bearer ${getWithExpiry(JWT_KEY)}`,
});

export const getAllSuperStaffCategories = async () => {
  try {
    const response = await fetch(`${BACKEND_URL}api/v1/superStaffCategory`, {
      headers: getAuthHeader(),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in getAllSuperStaffCategories: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (getAllSuperStaffCategories): ', data);
    return { data };
  } catch (err) {
    console.error('Error getAllSuperStaffCategories:', err);
    return { errors: err.message };
  }
};

export const getSuperStaffCategoryHierarchy = async () => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/superStaffCategory/hierarchy`,
      {
        headers: getAuthHeader(),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in getSuperStaffCategoryHierarchy: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (getSuperStaffCategoryHierarchy): ', data);
    return { data };
  } catch (err) {
    console.error('Error getSuperStaffCategoryHierarchy:', err);
    return { errors: err.message };
  }
};

export const getSuperStaffCategoryById = async (superStaffCategoryId) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/superStaffCategory/${superStaffCategoryId}`,
      {
        headers: getAuthHeader(),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in getSuperStaffCategoryById: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (getSuperStaffCategoryById): ', data);
    return { data };
  } catch (err) {
    console.error('Error getSuperStaffCategoryById:', err);
    return { errors: err.message };
  }
};

export const createSuperStaffCategory = async (category) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/superStaffCategory/admin`,
      {
        method: 'POST',
        mode: 'cors',
        headers: getAuthHeader(),
        body: JSON.stringify({ category }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in createSuperStaffCategory: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (createSuperStaffCategory): ', data);
    return { data };
  } catch (err) {
    console.error('Error createSuperStaffCategory:', err);
    return { errors: err.message };
  }
};

export const updateSuperStaffCategory = async (superStaffCategoryId, category) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/superStaffCategory/admin/${superStaffCategoryId}`,
      {
        method: 'PUT',
        mode: 'cors',
        headers: getAuthHeader(),
        body: JSON.stringify({ category }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in updateSuperStaffCategory: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (updateSuperStaffCategory): ', data);
    return { data };
  } catch (err) {
    console.error('Error updateSuperStaffCategory:', err);
    return { errors: err.message };
  }
};

export const deleteSuperStaffCategory = async (superStaffCategoryId) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/superStaffCategory/admin/${superStaffCategoryId}`,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: getAuthHeader(),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in deleteSuperStaffCategory: ', errorText);
      return { errors: errorText };
    }

    const text = await response.text();
    const data = text ? JSON.parse(text) : { success: true };
    console.log('RESULT (deleteSuperStaffCategory): ', data);
    return { data };
  } catch (err) {
    console.error('Error deleteSuperStaffCategory:', err);
    return { errors: err.message };
  }
};

export const createStaffCategoryAndAddToSuper = async (
  superStaffCategoryId,
  category
) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/superStaffCategory/admin/${superStaffCategoryId}/staffCategory`,
      {
        method: 'POST',
        mode: 'cors',
        headers: getAuthHeader(),
        body: JSON.stringify({ category }),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        'ERROR in createStaffCategoryAndAddToSuper: ',
        errorText
      );
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (createStaffCategoryAndAddToSuper): ', data);
    return { data };
  } catch (err) {
    console.error('Error createStaffCategoryAndAddToSuper:', err);
    return { errors: err.message };
  }
};

export const addStaffCategoryToSuper = async (
  superStaffCategoryId,
  staffCategoryId
) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/superStaffCategory/admin/${superStaffCategoryId}/staffCategory/${staffCategoryId}`,
      {
        method: 'POST',
        mode: 'cors',
        headers: getAuthHeader(),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in addStaffCategoryToSuper: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (addStaffCategoryToSuper): ', data);
    return { data };
  } catch (err) {
    console.error('Error addStaffCategoryToSuper:', err);
    return { errors: err.message };
  }
};

export const getCustomersByStaffCategory = async (staffCategoryId) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/staffCategory/${staffCategoryId}/customers`,
      {
        headers: getAuthHeader(),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in getCustomersByStaffCategory: ', errorText);
      return { errors: errorText };
    }

    const data = await response.json();
    console.log('RESULT (getCustomersByStaffCategory): ', data);
    return { data };
  } catch (err) {
    console.error('Error getCustomersByStaffCategory:', err);
    return { errors: err.message };
  }
};

export const removeStaffCategoryFromSuper = async (
  superStaffCategoryId,
  staffCategoryId
) => {
  try {
    const response = await fetch(
      `${BACKEND_URL}api/v1/superStaffCategory/admin/${superStaffCategoryId}/staffCategory/${staffCategoryId}`,
      {
        method: 'DELETE',
        mode: 'cors',
        headers: getAuthHeader(),
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error('ERROR in removeStaffCategoryFromSuper: ', errorText);
      return { errors: errorText };
    }

    const text = await response.text();
    const data = text ? JSON.parse(text) : { success: true };
    console.log('RESULT (removeStaffCategoryFromSuper): ', data);
    return { data };
  } catch (err) {
    console.error('Error removeStaffCategoryFromSuper:', err);
    return { errors: err.message };
  }
};
